export default "__VITE_ASSET__a0561cc5__"